var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getFuseThemesConfig } from '../../fuse-configs/fuseThemesConfig';
import * as _ from 'lodash';
import dark from '../colors/dark';
import lightBlue from '@material-ui/core/colors/lightBlue';
import red from '@material-ui/core/colors/red';
var mustHaveOptions = {
    typography: {
        htmlFontSize: 10,
    },
};
export var defaults = {
    default: {
        palette: {
            type: 'light',
            primary: dark,
            secondary: {
                light: lightBlue[400],
                main: lightBlue[600],
                dark: lightBlue[700],
            },
            error: red,
        },
        status: {
            danger: 'orange',
        },
    },
    defaultDark: {
        palette: {
            type: 'dark',
            primary: dark,
            secondary: {
                light: lightBlue[400],
                main: lightBlue[600],
                dark: lightBlue[700],
            },
            error: red,
        },
        status: {
            danger: 'orange',
        },
    },
};
export var FuseSelectedTheme;
var themesObj = function (tubeColor) {
    var fuseThemesConfig = getFuseThemesConfig(tubeColor);
    return Object.keys(fuseThemesConfig).length !== 0 ? fuseThemesConfig : defaults;
};
var getTheme = function (tubeColor) {
    return Object.assign.apply(Object, __spreadArray([{}], Object.entries(themesObj(tubeColor)).map(function (_a) {
        var _b;
        var key = _a[0], value = _a[1];
        // @ts-ignore
        var muiTheme = createMuiTheme(_.merge({}, value, mustHaveOptions));
        return _b = {},
            _b[key] = createMuiTheme(_.merge({}, muiTheme, { mixins: customMixins(muiTheme) })),
            _b;
    })));
};
export var themes = getTheme();
function customMixins(theme) {
    return {
        border: function (width) {
            if (width === void 0) { width = 1; }
            return ({
                borderWidth: width,
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
            });
        },
        borderLeft: function (width) {
            if (width === void 0) { width = 1; }
            return ({
                borderLeftWidth: width,
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
            });
        },
        borderRight: function (width) {
            if (width === void 0) { width = 1; }
            return ({
                borderRightWidth: width,
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
            });
        },
        borderTop: function (width) {
            if (width === void 0) { width = 1; }
            return ({
                borderTopWidth: width,
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
            });
        },
        borderBottom: function (width) {
            if (width === void 0) { width = 1; }
            return ({
                borderBottomWidth: width,
                borderStyle: 'solid',
                borderColor: theme.palette.divider,
            });
        },
    };
}
function updateLightDarkThemes(val, tubeColor) {
    var newThemes = themesObj(tubeColor);
    var theme = newThemes[val];
    themes = __assign(__assign({}, getTheme(tubeColor)), { mainThemeDark: createMuiTheme(_.merge({}, theme, __assign({ palette: { type: 'dark' } }, mustHaveOptions))), mainThemeLight: createMuiTheme(_.merge({}, theme, __assign({ palette: { type: 'light' } }, mustHaveOptions))) });
}
var FuseTheme = /** @class */ (function (_super) {
    __extends(FuseTheme, _super);
    function FuseTheme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            theme: null,
            tubeColor: null,
        };
        return _this;
    }
    FuseTheme.getDerivedStateFromProps = function (nextProps, prevState) {
        themes = getTheme(prevState.tubeColor);
        FuseSelectedTheme = themes[nextProps.selectedTheme];
        updateLightDarkThemes(nextProps.selectedTheme, nextProps.tubeColor);
        var selected = themes[nextProps.selectedTheme];
        return !_.isEqual(prevState.theme, selected)
            ? {
                theme: selected,
                tubeColor: nextProps.tubeColor,
            }
            : null;
    };
    FuseTheme.prototype.render = function () {
        var children = this.props.children;
        var theme = this.state.theme;
        return React.createElement(MuiThemeProvider, { theme: theme }, children);
    };
    return FuseTheme;
}(React.PureComponent));
function mapStateToProps(_a) {
    var fuse = _a.fuse, auth = _a.auth;
    return {
        selectedTheme: fuse.settings.current.theme.main,
        // Added as a quick fix a very specific issue.
        tubeColor: auth.tube.color === '#' ? '#9C3296' : auth.tube.color,
    };
}
export default withRouter(connect(mapStateToProps, null)(FuseTheme));



//////////////////
// WEBPACK FOOTER
// ./src/theme/theme/index.tsx
// module id = 265
// module chunks = 81